import { Link } from 'react-router-dom';
import { Mail, Instagram } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LOGO_URL = "/logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isAuthenticated } = useAuth();

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Tune4Tune" 
                className="h-12 w-auto"
              />
              <span className="font-heading font-bold text-xl">Tune4Tune</span>
            </Link>
            <p className="text-[#A1A1AA] text-sm max-w-md mb-4">
              Your direct connection to Caribbean Dancehall and Reggae legends. 
              Get custom dubplates, personalized drops, and exclusive voiceovers from top artists.
            </p>
            <p className="text-[#666] text-sm">
              Created by <span className="text-lime font-semibold">Code Red Sound</span>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/artists" className="text-[#A1A1AA] hover:text-lime transition-colors text-sm">
                  Browse Artists
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#A1A1AA] hover:text-lime transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#A1A1AA] hover:text-lime transition-colors text-sm" data-testid="footer-faq-link">
                  FAQ
                </Link>
              </li>
              {!isAuthenticated && (
                <>
                  <li>
                    <Link to="/register" className="text-[#A1A1AA] hover:text-lime transition-colors text-sm">
                      Sign Up
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" className="text-[#A1A1AA] hover:text-lime transition-colors text-sm">
                      Login
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold mb-4">Connect</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:coderedmusicgroup@gmail.com" 
                  className="text-[#A1A1AA] hover:text-lime transition-colors text-sm flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  coderedmusicgroup@gmail.com
                </a>
              </li>
              <li>
                <a 
                  href="https://instagram.com/coderedsound" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#A1A1AA] hover:text-lime transition-colors text-sm flex items-center gap-2"
                >
                  <Instagram className="w-4 h-4" />
                  @coderedsound
                </a>
              </li>
              <li>
                <a 
                  href="https://instagram.com/codelank" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#A1A1AA] hover:text-lime transition-colors text-sm flex items-center gap-2"
                >
                  <Instagram className="w-4 h-4" />
                  @codelank
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#1A1A1A] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#666] text-sm">
            © {currentYear} Tune4Tune. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-[#666]">
            <Link to="/about" className="hover:text-lime transition-colors">
              About
            </Link>
            <span className="text-[#333]">•</span>
            <Link to="/privacy" className="hover:text-lime transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <span className="text-[#333]">•</span>
            <Link to="/terms" className="hover:text-lime transition-colors" data-testid="footer-terms-link">
              Terms of Service
            </Link>
            <span className="text-[#333]">•</span>
            <Link to="/legal/subprocessors" className="hover:text-lime transition-colors" data-testid="footer-subprocessors-link">
              Subprocessors
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
